import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const dealersRequest = createAction(types.DEALERS_REQUEST);
export const dealersSuccess = createAction(types.DEALERS_SUCCESS);
export const dealersFailure = createAction(types.DEALERS_FAILURE);

export const dealerRequest = createAction(types.DEALER_REQUEST);
export const dealerSuccess = createAction(types.DEALER_SUCCESS);
export const dealerFailure = createAction(types.DEALER_FAILURE);

export const dealerStatusRequest = createAction(types.DEALER_STATUS_REQUEST);
export const dealerStatusSuccess = createAction(types.DEALER_STATUS_SUCCESS);
export const dealerStatusFailure = createAction(types.DEALER_STATUS_FAILURE);

export const createDealerRequest = createAction(types.CREATE_DEALER_REQUEST);
export const createDealerSuccess = createAction(types.CREATE_DEALER_SUCCESS);
export const createDealerFailure = createAction(types.CREATE_DEALER_FAILURE);

export const updateDealerRequest = createAction(types.UPDATE_DEALER_REQUEST);
export const updateDealerSuccess = createAction(types.UPDATE_DEALER_SUCCESS);
export const updateDealerFailure = createAction(types.UPDATE_DEALER_FAILURE);

export const deleteDealerRequest = createAction(types.DELETE_DEALER_REQUEST);
export const deleteDealerSuccess = createAction(types.DELETE_DEALER_SUCCESS);
export const deleteDealerFailure = createAction(types.DELETE_DEALER_FAILURE);

export const modifyDealerTmpStateRequest = createAction(
  types.MODIFY_DEALER_TMP_STATE_REQUEST,
);
export const modifyDealerTmpStateSuccess = createAction(
  types.MODIFY_DEALER_TMP_STATE_SUCCESS,
);
export const modifyDealerTmpStateFailure = createAction(
  types.MODIFY_DEALER_TMP_STATE_FAILURE,
);

export const inventoryImportRequest = createAction(
  types.INVENTORY_IMPORT_REQUEST,
);
export const inventoryImportSuccess = createAction(
  types.INVENTORY_IMPORT_SUCCESS,
);
export const inventoryImportFailure = createAction(
  types.INVENTORY_IMPORT_FAILURE,
);

export const dealerYMMTRequest = createAction(types.DEALER_YMMT_REQUEST);
export const dealerYMMTSuccess = createAction(types.DEALER_YMMT_SUCCESS);
export const dealerYMMTFailure = createAction(types.DEALER_YMMT_FAILURE);

export const dealerPriceRulesFetchRequest = createAction(
  types.DEALER_PRICE_RULES_FETCH_REQUEST,
);
export const dealerPriceRulesFetchSuccess = createAction(
  types.DEALER_PRICE_RULES_FETCH_SUCCESS,
);
export const dealerPriceRulesFetchFailure = createAction(
  types.DEALER_PRICE_RULES_FETCH_FAILURE,
);

export const dealerPriceRulesUpdateRequest = createAction(
  types.DEALER_PRICE_RULES_UPDATE_REQUEST,
);
export const dealerPriceRulesUpdateSuccess = createAction(
  types.DEALER_PRICE_RULES_UPDATE_SUCCESS,
);
export const dealerPriceRulesUpdateFailure = createAction(
  types.DEALER_PRICE_RULES_UPDATE_FAILURE,
);

export const resetDealer = createAction(types.RESET_DEALER);

export const setDealerThemeRequest = createAction(
  types.SET_DEALER_THEME_REQUEST,
);
export const setDealerThemeSuccess = createAction(
  types.SET_DEALER_THEME_SUCCESS,
);
export const setDealerThemeFailure = createAction(
  types.SET_DEALER_THEME_FAILURE,
);

export default {
  resetDealer,
  dealersRequest,
  dealersSuccess,
  dealersFailure,
  dealerRequest,
  dealerSuccess,
  dealerFailure,
  dealerStatusRequest,
  dealerStatusSuccess,
  dealerStatusFailure,
  createDealerRequest,
  createDealerSuccess,
  createDealerFailure,
  updateDealerRequest,
  updateDealerSuccess,
  updateDealerFailure,
  deleteDealerRequest,
  deleteDealerSuccess,
  deleteDealerFailure,
  modifyDealerTmpStateRequest,
  modifyDealerTmpStateSuccess,
  modifyDealerTmpStateFailure,
  inventoryImportRequest,
  inventoryImportSuccess,
  inventoryImportFailure,
  dealerYMMTRequest,
  dealerYMMTSuccess,
  dealerYMMTFailure,
  dealerPriceRulesFetchRequest,
  dealerPriceRulesUpdateRequest,
  dealerPriceRulesFetchFailure,
  dealerPriceRulesUpdateSuccess,
  dealerPriceRulesUpdateFailure,
  dealerPriceRulesFetchSuccess,
  setDealerThemeRequest,
  setDealerThemeSuccess,
  setDealerThemeFailure,
};
